const trips = {
  trips: 'Trips',

  stopTypes: {
    charging: '',
    cluster: '(Cluster Center)',
  },
  statuses: {
    new: 'New',
    in_route: 'Inroute',
    sent: 'Sent',
    approved: 'Approved',
    done: 'Done',
    canceled: 'Canceled',
  },
  driverActions: {
    more: 'More',
    send: 'Send',
    call: 'Call',
    note: 'Note',
  },
  moreActions: {
    actions: 'More',
    sendTrip: {
      title: 'Send Trip',
      body: 'You are about to send {{tripsCount}} trips.',
    },
    delete: {
      title: 'Delete',
      body: 'You are about to delete {{tripsCount}} trips.',
    },
    addNote: {
      title: 'Add Note',
      body: 'You are about to add a note to {{tripsCount}} trips.',
    },
    showOnMap: 'Show On Map',
    sendMessage: {
      title: 'Send Message',
      body: 'You are about to send a message to {{tripsCount}} drivers.',
    },
    merge: {
      title: 'Merge trips',
      body: 'You are about to merge {{tripsCount}} trips.',
    },
    cancelTrip: {
      title: 'Cancel Trip',
      body: 'You are about to cancel {{tripsCount}} trips.',
    },
    export: 'Export',
    tripReports: 'Trip Reports',
    clearAssinment: {
      title: 'Clear Assignment',
      body: 'You are about to clear assignment for {{tripsCount}} trips.',
      confirmButton: 'Confirm',
      checkBoxSkipManuallyAssigned: 'Skip manual assignments in this interface',
    },
    exportToKml: {
      title: 'Export KMLs',
      body: 'You are about to export KML files for {{tripsCount}} trips.',
    },
    exportTripDirections: {
      title: 'Export Trip Directions',
      body: 'You are about to export Excel files for {{tripsCount}} trips.',
    },
    exportToOptibus: {
      body: 'Select an Optibus project to export the trips to:',
    },
  },
  tripInfo: {
    title: 'Trip  ',
    formTabs: {
      detailsTab: 'Details',
      historyTab: 'History',
      assignInsightsTab: 'Assign Insights',
      analysis: 'Analysis',
    },
    driverActions: {
      note: 'Note',
      call: 'Call',
      send: 'Send',
      more: 'More',
    },
    toast: {
      assignment: 'Trip assigned successfully',
      toastSomethingWasWrong: 'Something was wrong',
      toastActionEndTrip: 'End trip available when all passengers are dropped',
    },
    selectDriver: 'Select Driver',
    selectVehicle: 'Select Vehicle',
    bookingDetails: {
      title: 'Booking Details',
    },
    status: 'Status',
    headerBreakDown: 'Trip Breakdown',
    driverNotAssigned: 'Driver Not Assigned',
    vehicleNotAssigned: 'Vehicle Not Assigned',
    noDriver: 'No Driver',
    noCar: 'No Vehicle',
    noService: 'No Service',
    seats: 'Seats',
    originalStation: 'Original Station: ',
    newStation: 'New Station: ',
    moveStopHeader: 'You are about to move stop in trip: {{ tripId }}',
    date: 'Date',
    pickupTime: 'Pickup time',
    eta: 'Next Stop ETA',
    passengers: 'Passengers',
    stops: 'Stops',
    distance: 'Distance',
    miles: 'ml',
    kilometers: 'km',
    accept: 'Accept',
    decline: 'Decline',
    map: {
      switchRoute: {
        toasts: {
          success: 'Route successfully switched',
          failure: 'An error occured switching the route',
        },
      },
      operators: {
        fetchError: 'Unable to fetch operators',
        placeholder: 'Operators',
        submit: {
          toasts: {
            success: 'Operators successfuly updated',
            error: 'Unable to update operators',
          },
        },
      },
      stopClusterDistance: ' ({{distance}}m to cluster)',
    },
    modalEndTrip: {
      body: 'Please mark all passengers as dropped-off',
      header: 'Warning!',
    },
    tripActions: {
      tripBreakdown: 'Trip Breakdown',
      note: 'Add note',
      history: 'History',
      msg: 'Send driver a message',
      moveToCustomRulesLabel: 'Create Custom Rule',
      start: {
        name: 'Start trip',
        title: 'Action available for status Approved',
      },
      end: {
        name: 'End trip',
        title: 'End trip available when all passengers are dropped',
      },
      cancel: 'Cancel trip',
      breakdown: 'Trip Breakdown',
    },
    stopActions: {
      queue: 'Add to queue',
    },
    passengerActions: {
      queue: 'Add to queue',
    },
    assignLog: {
      button: 'Assign Info',
      closeButton: 'Assign Log',
      table: {
        headers: {
          driver: 'Driver',
          vehicle: 'Vehicle',
          score: 'Score',
          flag: 'Flag',
          minutes: 'Minutes',
          radius: 'Radius',
          seatCount: 'Seat Count',
          totalTrips: 'Total Trips',
          totalPrice: 'Total Price',
        },
      },
    },
    analysis: {
      header: 'Additional details on manual actions can be found in the Trip/Bookings History tab',
      table: {
        headers: {
          name: 'Name',
          type: 'Type',
          description: 'Description',
          conflict: 'Conflict',
          item1: 'item 1',
          item2: 'Item 2',
          origin: 'Origin',
          source: 'Source',
        },
      },
    },
    breakdown: {
      table: {
        headers: {
          id: 'ID',
          planned: 'Planned time',
          date: 'Requested time',
          passenger: 'Passenger',
          type: 'Type',
          from: 'From',
          to: 'To',
          vin: 'VIN',
          make: 'Make',
          model: 'Modal',
          year: 'Year',
          weight: 'Weight',
          height: 'Height',
          width: 'Width',
          length: 'Length',
          price: 'Price',
        },
      },
    },
    tripsInfoPlans: {
      toastStatusChanged: 'Status changed',
      toastStopRemoved: 'Stop removed',
      toastTripRemoved: '[Trips] Successfully Removed',
      toastTripRemoveError: '[Trips] Could not Remove',
      toastClearSuccess: '[Trips] Drivers and Vehicles were cleared successfully',
      toastClearError: '[Trips] Drivers and Vehicles were cleared successfully',
      toastTripCanceled: '[Trips] Successfully Canceled',
      toastTripCanceledError: '[Trips] Could not Canceled',
      toastJobRemoved: 'Reservation removed',
      toastJobCanceld: 'Reaervation has been successfully canceled',
      toastSomethingWasWrong: 'Something was wrong',
      toastMergeSuccess: 'Trips were successfully merged',
      toastMergeManyLockedAssignments: 'Can\'t merge trips because they have multiple different locked assignments',
      toastMergeError: 'One of the trips is not available for merge',
      btnRemoveStop: 'Remove',
      reservationActions: {
        btnPickUp: {
          name: 'Picked up',
          title: 'Avalable only for status in route',
        },
        btnDroppoff: {
          name: 'Dropped off',
          title: 'Avalable only for status in route',
        },
        btnNoShow: {
          name: 'No Show',
          title: 'Avalable only for status in route',
        },
        btnCancel: 'Cancel Reservation',
        btnRemove: 'Remove From Trip',
      },
    },
    events: {
      chargingStationAdded: 'Charging Station Added',
    },
    moveReservation: {
      successToast: 'Stops reordered successfully',
      errorToast: 'Failed to move the reservation',
    },
    moveStops: {
      successToast: 'Reservation moved successfully',
      errorToast: 'Failed to reorder stops',
    },
  },
  edit: {
    applyingEditChanges: 'Applying changes',
    progress: {
      toastSuccess: 'Waypoints saved',
      toastError: 'Failed to apply waypoints',
    },
    unsaved: {
      header: 'Unsaved Changes',
      body: 'You have unsaved changes. What would you like to do?',
      confirm: 'Discard changes',
      cancel: 'Keep Changes',
    },
  },

  table: {
    floatingActions: {
      tooltips: {
        deleteNotNew: 'At least one trip is not in status new',
        noPermission: 'Action not allowed: Permission required',
        accept: 'This action is only available for trips with `Accept` or `Decline` status.',
        decline: 'This action is only available for trips with `Accept` or `Decline` status.'
      },
      assign: 'Assign',
      distribute: 'Distribute',
      send: 'Send',
      cancel: 'Cancel',
      delete: 'Delete',
      export: 'Export',
      merge: 'Merge',
      sendMessage: 'Send Message',
      tripReport: 'Trip Report',
      showOnMap: 'Show On Map',
      addNote: 'Add Note',
      exportToKml: 'Export to KML',
      exportTripDirections: 'Export Trip Directions',
      exportToOptibusPlanning: 'Export to Planning',
      exportToOptibusScheduling: 'Export to Scheduling',
      accept: 'Accept',
      decline: 'Decline',
    },
    filters: {
      status: 'Status',
      profile: 'Profiles',
      attributes: 'Attributes',
      supplier: 'Suppliers',
      driver: 'Driver',
      vehicle: 'Vehicle',
      from: 'From',
      to: 'To',
      locations: 'Locations',
      airportLocations: 'Airport Locations',
      flightNumber: 'Flight Number',
      airline: 'Airline',
      flightStatus: 'Flight Status',
      productionId: 'Production ID',
      drivers: {
        onlyWithout: 'Unassigned Trips',
        onlyWith: 'Assigned Trips',
        all: 'Assigned & Unassigned ',
      },
      vehicles: {
        onlyWithout: 'Vehicle Unassigned',
        onlyWith: 'Vehicle Assigned',
        all: 'Assigned & Unassigned',
      },
      indicators: 'Indicators',
      areas: 'Zones',
    },
    buttons: {
      driver: 'Driver',
      vehicle: 'Vehicle',
    },
    statuses: {
      new: 'New',
      inRoute: 'In Route',
      sent: 'Sent',
      approved: 'Approved',
      pickingUp: 'Picking up',
      done: 'Done',
      canceled: 'Canceled',
    },
    indicators: {
      sharedTrip: 'Shared Trip',
      merged: 'Merged',
      waitAndReturn: 'Wait & Return',
      manuallyAssigned: 'Manually Assigned',
      roundTrip: 'Two Way',
      consistentPassengerRouting: 'Consistent Passenger Routing',
      manualDispatched: 'Manual Dispatched',
      error: 'Investigation',
    },
    headers: {
      id: 'ID',
      indicators: 'Indicators',
      status: 'Status',
      date: 'Date',
      from: 'From',
      to: 'To',
      seats: 'Seats',
      passenger: 'Passenger',
      profile: 'Profile',
      stops: 'Stops',
      distance: 'Distance',
      duration: 'Duration',
      service: 'Service',
      flightInfo: 'Flight Info',
      flightNumber: 'Flight Number',
      airline: 'Airline',
      scheduledFlightTime: 'Scheduled Flight Time',
      actualFlightTime: 'Actual Flight Time',
      flightStatus: 'Flight Status',
      supplier: 'Supplier',
      driver: 'Driver',
      car: 'Vehicle',
      actions: 'Actions',
      attr: 'Attributes',
      externalId: 'External Id',
      waitUntil: 'Wait until',
      line: 'Line',
      price: 'Price',
      reservationsExtendUntilDate: 'Wait Until',
      areas: 'Zones',
      cost: 'Cost',
    },
    footer: {
      totalSeats: 'Total Seats: {{seats}}',
    },
    cells: {
      isTwoWay: {
        toolTip: 'Two Way',
      },
      shared: {
        toolTip: 'Shared Trip',
      },
      waitAndReturn: {
        toolTip: 'Wait And Return',
      },
      merged: {
        toolTip: 'Merged Trip',
      },
      chargingStops: {
        toolTip: 'Charging Stops',
      },
      manualAssignment: {
        integration: {
          toolTip: 'Manually Assigned ({{reason}})',
        },
        noIntegration: {
          toolTip: 'Manually Assigned',
        },
      },
      bypassed: {
        toolTip: 'Settings bypassed by manual action',
      },
      isManuallyAltered: {
        toolTip: 'Manual Dispatched',
      },
      manualDispatch: {
        and: '&',
        reason: {
          grouped: 'Grouped',
          manualRoute: 'Manual Route',
          dragAndDrop: 'Drag and Drop',
          manualRouteIntegration: 'Manual Route (Integration)'
        },
      },
      car: {
        none: 'No Vehicles',
      },
      driver: {
        none: 'No Driver',
      },
      supplier: {
        none: 'No Supplier',
      },
      isConsistentPassengerRouting: {
        toolTip: 'Consistent Passenger Routing',
      },
      actions:{
        approve: 'Approve',
        remove: 'Remove'
      },
    },
    actions: {
      autoAssign: {
        modal: {
          header: 'Assignment Summary',
          body: {
            trips: {
              total: 'Total Trips',
              assigned: 'Total Assigned',
              unassigned: 'Unassigned',
            },
            drivers: {
              preAssigned: 'Pre-Assigned',
              autoAssigned: 'Auto Assigned',
              total: 'Total Drivers',
              totalDriversAssigned: 'Total Assigned',
              unassigned: 'Unassigned',
            },
            vehicles: {
              total: 'Total Vehicles',
              used: 'Total Assigned',
            },
            insights: {
              title: 'Assignment Insights Per Driver',
              assignmentTime: 'Assignment Process Time',
              avgDistance: 'Average Trip Distances',
              avgDistanceToPickup: 'Average  Deadhead Driving Distance',
              avgDuration: 'Average Trip Duration',
              avgDurationToPickup: 'Average Deadhead Driving Duration',
              avgPrice: 'Average Price',
              waitAvg: 'Average Idle Time',
            },
          },
        },
        errorModal: {
          header: 'Error',
          body: 'All selected trips were already assigned. To re-assign drivers please clear the current assignment first.',
        },
      },
      assign: {
        assign: 'Assign',
        clearDriversVehicle: 'Clear Drivers/Vehicles',
        advancedAssign: 'Advanced Assign',
        modalHeader: 'Assign Trips',
        youAreAboutToAssign: 'You are about to assign {{numberOfTrips}} trips.',
        youAreAboutToDistribute: 'You are about to distribute {{numberOfTrips}} trips.',
        assignError: 'Error assigning trips',
      },
      merge: {
        errorMessage: 'Additional trip was not found to merge',
        shuttle: 'Shuttle trips are not allowed to be merged',
      },
      showOnMap: {
        header: 'Show On Map',
        shuttle: 'Shuttle trips are not allowed to be merged',
      },
      export: {
        optibus: {
          header: 'Projects',
          placeholder: 'Select project',
          export: 'Export',
          success: 'The selected trips were successfully sent to the selected Optibus project.',
        },
      },
      cancelReservation: 'You are about to cancel this reservation',
      report: {
        header: 'Route Summary',
        body: {
          totalTrips: 'Trips',
          totalCost: 'Cost',
          totalPrice: 'Price',
          totalJobs: 'Reservations',
          totalDuration: 'Duration',
          totalDistance: 'Distance',
          totalAssigned: 'Assigned',
          totalUnassigned: 'Unassigned',
          totalDrivers: 'Drivres',
          averageJobs: 'Avg. Reservations',
          averageDistance: 'Avg. Distance',
          averageDuration: 'Avg. Duration',
        },
      },
    },
  },
};

export default trips;
